<div class="ai-panel-modal" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <h2>AI Panel</h2>

    <div class="fs-12">Model</div>
    <select
      class="ai-provider-selector"
      [value]="model$ | async"
      (change)="onModelChange($event)"
    >
      <option value="openai">OpenAI</option>
      <option value="claude">Claude</option>
    </select>

    <div class="fs-12">Prompt</div>
    <textarea
      class="ai-panel-textarea"
      rows="4"
      [value]="prompt$ | async"
      placeholder="Tell your story"
      (keyup.enter)="$event.stopPropagation(); onGenerateScenes()"
      (keyup)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (change)="onPromptChange($event)"
    ></textarea>

    <div
      *ngIf="!(loading$ | async)"
      (click)="onGenerateScenes()"
      class="fs-12 pointer button"
    >
      Generate scenes
    </div>

    <div *ngIf="loading$ | async" class="loading">Loading...</div>
    <div *ngIf="error$ | async as error" class="error">Error: {{ error }}</div>
    <!-- <div *ngIf="data$ | async as data">
      <pre>{{ data | json }}</pre>
    </div> -->
    <ng-content></ng-content>
    <div *ngIf="scenes$ | async as scenes">
      <div class="mv-6">Scenes</div>
      <div class="flex-column gap-4">
        <div class="scene-item fs-11" *ngFor="let scene of scenes">
          {{ scene.description }}
        </div>
      </div>
    </div>
  </div>
</div>
